import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { documentsKeys } from './queryKeyFactory';
import { useContext } from 'react';
import ServicesContext from '../../global/services/ServicesContext';
import { GetDocumentMetadataRequest } from '../../Model/requests/GetDocumentMetadataRequest';
import { GearDocumentMetadata } from '../../Model/GearDocumentMetadata';
import { ResponseWithHeaders } from '../../Model/ResponseWithHeaders';

export function useGetDocumentMetadata(
  dto?: GetDocumentMetadataRequest
): UseQueryResult<ResponseWithHeaders<{ metadata: GearDocumentMetadata }>, unknown> {
  const servicesCtx = useContext(ServicesContext);

  const getDocumentMetadata = () => {
    if (servicesCtx?.documentsService && dto) {
      return servicesCtx.documentsService.getDocumentMetadata(dto);
    }
    throw new Error('Services context not initialized');
  };

  return useQuery({
    queryKey: documentsKeys.documentMetadata(dto),
    queryFn: getDocumentMetadata,
    retry: 0,
    staleTime: 180000,
    gcTime: 180000,
    enabled: !!dto,
    refetchOnMount: 'always'
  });
}
